import gameBack from '../assets/img/header-form-game-back.svg';

const headerBlock = {
    years: {
        text: "15+",
        description: "header.experience-block.years",
    },
    engineers: {
        text: "40+",
        description: "header.experience-block.engineers",
    },
    clients: {
        text: "120+",
        description: "header.experience-block.clients",
    },
}

export {
    headerBlock,
    gameBack,
};
